import type { ApiRequestFn } from "../../types/api";
import type { Provider } from "../../types/models";

const createProvidersApi = (request: ApiRequestFn) => ({
  list: () => request<Provider[]>("/providers"),
  get: (id: number) => request<Provider>(`/providers/${id}`),
});

export { createProvidersApi };
